// OneDrive:IgnoreCodeCoverage

export const enum SharingInfoType {
    Email = 0,
    User = 1,
    Group = 2,
    Link = 3,
    Public = 4,
    Friends = 5,
    Facebook = 6,
    Application = 7,
    GroupOwned = 99
}
